/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1TutoraiDocumentsClassstudentidMutationRequest,
  PostApiV1TutoraiDocumentsClassstudentidMutationResponse,
  PostApiV1TutoraiDocumentsClassstudentidPathParams,
  PostApiV1TutoraiDocumentsClassstudentid400,
  PostApiV1TutoraiDocumentsClassstudentid401,
  PostApiV1TutoraiDocumentsClassstudentid500,
} from "../../types/tutorAIDocumentosController/PostApiV1TutoraiDocumentsClassstudentid.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1TutoraiDocumentsClassstudentid } from "../../clients/tutorAIDocumentosController/postApiV1TutoraiDocumentsClassstudentid.ts";

export const postApiV1TutoraiDocumentsClassstudentidMutationKey = () =>
  [{ url: "/api/v1/tutorai/documents/:classStudentId" }] as const;

export type PostApiV1TutoraiDocumentsClassstudentidMutationKey = ReturnType<
  typeof postApiV1TutoraiDocumentsClassstudentidMutationKey
>;

export function postApiV1TutoraiDocumentsClassstudentidMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1TutoraiDocumentsClassstudentidMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = postApiV1TutoraiDocumentsClassstudentidMutationKey();
  return mutationOptions<
    PostApiV1TutoraiDocumentsClassstudentidMutationResponse,
    ResponseErrorConfig<
      | PostApiV1TutoraiDocumentsClassstudentid400
      | PostApiV1TutoraiDocumentsClassstudentid401
      | PostApiV1TutoraiDocumentsClassstudentid500
    >,
    {
      classStudentId: PostApiV1TutoraiDocumentsClassstudentidPathParams["classStudentId"];
      data?: PostApiV1TutoraiDocumentsClassstudentidMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ classStudentId, data }) => {
      return postApiV1TutoraiDocumentsClassstudentid(
        classStudentId,
        data,
        config,
      );
    },
  });
}

/**
 * @description Envia o arquivo para o TutorAI e cria o registro com status `Pending`. Formatos aceitos: PDF, MD, TXT. **(Requer Authorization para autenticação)**
 * @summary Upload de documento (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/documents/:classStudentId}
 */
export function usePostApiV1TutoraiDocumentsClassstudentid<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1TutoraiDocumentsClassstudentidMutationResponse,
      ResponseErrorConfig<
        | PostApiV1TutoraiDocumentsClassstudentid400
        | PostApiV1TutoraiDocumentsClassstudentid401
        | PostApiV1TutoraiDocumentsClassstudentid500
      >,
      {
        classStudentId: PostApiV1TutoraiDocumentsClassstudentidPathParams["classStudentId"];
        data?: PostApiV1TutoraiDocumentsClassstudentidMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1TutoraiDocumentsClassstudentidMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1TutoraiDocumentsClassstudentidMutationKey();

  const baseOptions = postApiV1TutoraiDocumentsClassstudentidMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1TutoraiDocumentsClassstudentidMutationResponse,
    ResponseErrorConfig<
      | PostApiV1TutoraiDocumentsClassstudentid400
      | PostApiV1TutoraiDocumentsClassstudentid401
      | PostApiV1TutoraiDocumentsClassstudentid500
    >,
    {
      classStudentId: PostApiV1TutoraiDocumentsClassstudentidPathParams["classStudentId"];
      data?: PostApiV1TutoraiDocumentsClassstudentidMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PostApiV1TutoraiDocumentsClassstudentidMutationResponse,
    ResponseErrorConfig<
      | PostApiV1TutoraiDocumentsClassstudentid400
      | PostApiV1TutoraiDocumentsClassstudentid401
      | PostApiV1TutoraiDocumentsClassstudentid500
    >,
    {
      classStudentId: PostApiV1TutoraiDocumentsClassstudentidPathParams["classStudentId"];
      data?: PostApiV1TutoraiDocumentsClassstudentidMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1TutoraiDocumentsClassstudentidMutationResponse,
    ResponseErrorConfig<
      | PostApiV1TutoraiDocumentsClassstudentid400
      | PostApiV1TutoraiDocumentsClassstudentid401
      | PostApiV1TutoraiDocumentsClassstudentid500
    >,
    {
      classStudentId: PostApiV1TutoraiDocumentsClassstudentidPathParams["classStudentId"];
      data?: PostApiV1TutoraiDocumentsClassstudentidMutationRequest;
    },
    TContext
  >;
}
